import React from 'react';

const StarOutlineICon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_12000_11296)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.59858 15.4489L7.89522 13.4508C8.57368 13.0396 9.42446 13.0395 10.103 13.4507L13.4015 15.4494L12.528 11.7057C12.3487 10.9376 12.6086 10.1334 13.2034 9.61547L16.1086 7.08548L12.2825 6.76058C11.4965 6.69383 10.8117 6.1981 10.5029 5.47221L9 1.93998L7.49712 5.47221C7.18827 6.19809 6.5035 6.69383 5.71747 6.76058L1.89144 7.08548L4.79664 9.61547C5.3914 10.1334 5.65127 10.9376 5.47205 11.7057L4.59858 15.4489ZM8.55761 14.5437C8.829 14.3792 9.16931 14.3792 9.44071 14.5436L13.6048 17.0668C14.25 17.4578 15.0474 16.8792 14.876 16.1446L13.7725 11.4153C13.7008 11.1081 13.8047 10.7864 14.0426 10.5792L17.7064 7.38862C18.2739 6.8944 17.9688 5.96091 17.2189 5.89724L12.3907 5.48723C12.0762 5.46053 11.8023 5.26224 11.6788 4.97188L9.78395 0.518404C9.48985 -0.1728 8.51015 -0.172801 8.21605 0.518403L6.3212 4.97188C6.19766 5.26223 5.92375 5.46053 5.60934 5.48723L0.781053 5.89724C0.031211 5.96091 -0.273874 6.8944 0.293637 7.38862L3.95739 10.5792C4.19529 10.7864 4.29924 11.1081 4.22755 11.4153L3.12406 16.1443C2.95263 16.8789 3.75017 17.4575 4.39532 17.0665L8.55761 14.5437Z'
          fill='#FFC500'
        />
      </g>
      <defs>
        <clipPath id='clip0_12000_11296'>
          <rect width='18' height='17.25' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarOutlineICon;
